export default __webpack_public_path__ + "static/media/user-position.dfa7a9cb.svg";